import { t } from '../../app/i18n';
import rules from '../../common/rules/rules';
import config from '../../config';

const amountFitsInAccoutBalanceAutomatic = (form, accountBalance, getInvestmentMaxStep) => [
  ...rules.required,
  rules.number,
  rules.positiveNumber,
  {
    validator: (rule, value, callback) => {
      callback(
        value &&
        !isNaN(parseInt(value, 10)) &&
        value > 0 &&
        value % getInvestmentMaxStep(value) !== 0
          ? t(`Hodnota musí byť násobok ${getInvestmentMaxStep(value)}`)
          : undefined
      );
    },
  },
  rules.amountLessThanBalance(accountBalance),
];

const amountFitsInAccoutBalance = (form, accountBalance, loanRemainingAmount) => [
  ...rules.required,
  rules.number,
  rules.positiveNumber,
  rules.divisibleBy(config.manualAllocationAmountDivisibleBy),
  {
    validator: (rule, value, callback) => {
      callback(
        parseInt(value, 10) > parseInt(loanRemainingAmount, 10)
          ? t('Prekročili ste veľkosť pôžičky')
          : undefined
      );
    },
  },
  rules.amountLessThanBalance(accountBalance),
];

export default {
  amountFitsInAccoutBalanceAutomatic,
  amountFitsInAccoutBalance,
};



// WEBPACK FOOTER //
// ./src/common/rules/allocationRules.js